/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionGroupSchema } from './ConditionGroupSchema';
import {
    ConditionGroupSchemaFromJSON,
    ConditionGroupSchemaFromJSONTyped,
    ConditionGroupSchemaToJSON,
    ConditionGroupSchemaToJSONTyped,
} from './ConditionGroupSchema';

/**
 * A condition with its root groups and a rendered summary.
 * 
 * ``summary`` is what the admin shows, and deliberately carries the validation error as its
 * text when the condition is unusable — that string is the most useful thing to display.
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    readonly summary: string;
    /**
     * 
     * @type {boolean}
     * @memberof Condition
     */
    readonly isUsable: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Condition
     */
    readonly problems: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    readonly version: string;
    /**
     * 
     * @type {Array<ConditionGroupSchema>}
     * @memberof Condition
     */
    readonly groups: Array<ConditionGroupSchema>;
}

/**
 * Check if a given object implements the Condition interface.
 */
export function instanceOfCondition(value: object): value is Condition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if ((!('isUsable' in (value as Record<string, any>)) && !('is_usable' in (value as Record<string, any>))) || ((value as Record<string, any>)['isUsable'] === undefined && (value as Record<string, any>)['is_usable'] === undefined)) return false;
    if (!('problems' in value) || value['problems'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    return true;
}

export function ConditionFromJSON(json: any): Condition {
    return ConditionFromJSONTyped(json, false);
}

export function ConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Condition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'summary': json['summary'],
        'isUsable': json['is_usable'],
        'problems': json['problems'],
        'version': json['version'],
        'groups': ((json['groups'] as Array<any>).map(ConditionGroupSchemaFromJSON)),
    };
}

export function ConditionToJSON(json: any): Condition {
    return ConditionToJSONTyped(json, false);
}

export function ConditionToJSONTyped(value?: Omit<Condition, 'id'|'summary'|'isUsable'|'problems'|'version'|'groups'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

